import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { getAreaInt, ActualizaArea } from "../../services/areas";
import { ErrorContext } from "../../utils/context/error";

function AreaModal({ show, AreaI, Tag, handleshow, fillAreas }) {
  const [habilita, setHabilita] = useState(false);
  const [AreaId, setAreaId] = useState(0);
  const [nombreArea, setNombre] = useState("");
  const [pagina, setPagina] = useState("");
  const [dispensador, setDispensa] = useState("");
  const [mensajeInf, setMensajeInf] = useState("NO");
  const [benefici, setBenefici] = useState("NO");
  const [codigoqr, setCodigoQr] = useState("NO");
  const [consult, setConsult] = useState("NO");
  const { setShowToast, setOpciones } = ErrorContext();
  const [Titulo, setTitulo] = useState("");

  const handleCancel = async () => 
    {
      handleshow(false);
    };

  const handleAceptar = async () => 
    {
      setHabilita(true);
      setShowToast(false);
      const response = await ActualizaArea({
        AreaId, 
        nombreArea, 
        pagina, 
        dispensador, 
        mensajeInf, 
        benefici,
        codigoqr,
        Tag,
        consult,
      });

      if (response) 
        {
          if (response.status === 200) 
            {
             fillAreas();
             handleshow(false);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
        }
       setHabilita(false);
    };

  const fillAreaInt = async (AreaId) => 
    {
      setShowToast(false);
      const response = await getAreaInt(AreaId);
      if (response) 
        {
           if (response.status === 200) 
            {
              setNombre(response.data.data[0].NombreArea);
              setPagina(response.data.data[0].Pagina);
              setDispensa(response.data.data[0].Dispensa);
              setMensajeInf(response.data.data[0].MensajeInf);
              setBenefici(response.data.data[0].Benefic);
              setCodigoQr(response.data.data[0].CodigoQr);
              setAreaId(response.data.data[0].AreaId);
              setConsult(response.data.data[0].Consult);
            } 
           else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
            }
        }
    };

  useEffect(() => 
    {
      if (show) 
        {
           setNombre("");
           setPagina("");
           setDispensa("");
           setMensajeInf("NO");
           setBenefici("NO");
           setCodigoQr("NO");
           setConsult("NO");

           if (Tag !== 0) 
            {
              fillAreaInt(AreaI);
              if (Tag === 1) setTitulo("Editar Area (" + AreaI + ")");
              if (Tag === 2) setTitulo("Eliminar Area (" + AreaI + ")");
            } 
           else 
            {
              setAreaId(0);
              setTitulo("Nueva Area");
            }
         }
    }, [show]);

  return (
    <>
        <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
           <div className="flex lg:w-[25rem]">
              <form noValidate className="flex flex-col w-full">
                  <div className="flex flex-col w-full h-full ">
                      <div className="w-full">
                        <label>Nombre Area</label>
                        <input type="text" name='searchid' value={nombreArea || ""} placeholder="Ingresa el nombre para el area" 
                                onChange={(e)=> setNombre(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                        </input>
                      </div>  
                      <div className="w-full mt-4">
                        <label>Página web</label>
                        <input type="text" name='searchid' value={pagina || ""} placeholder="Pagina web" 
                                onChange={(e)=> setPagina(e.target.value)}
                                autoComplete="off" 
                                disabled={Tag === 2}>
                        </input>
                      </div>  
                      <div className="w-full mt-4">
                          <label>Dispensador</label>
                          <select id="dispensador" name="dispensador" value={dispensador || ""} onChange={(e) => setDispensa(e.target.value)} label="Dispensador" disabled={Tag === 2 || Tag === 1}>
                              <option value="" disabled>
                                 Seleccionar modo Dispensador...
                              </option>
                              <option value="M">Manual</option>
                              <option value="A">Automatico</option>
                          </select>
                      </div>
                      <div className="flex mt-4">
                        <input type="checkbox" className="mr-2" checked={mensajeInf === "SI"} onChange={(e) => e.target.checked ? setMensajeInf("SI") : setMensajeInf("NO")} disabled={Tag === 2}/>
                        <label className="">Visualizar Mensajes Informativos</label>   
                      </div>
                      <div className="flex mt-2">
                        <input type="checkbox" className="mr-2" checked={benefici === "SI"} onChange={(e) => e.target.checked ? setBenefici("SI") : setBenefici("NO")} disabled={Tag === 2}/>
                        <label className="">Registrar Paciente que solicita turno ?</label>   
                      </div>
                      <div className="flex mt-2">
                        <input type="checkbox" className="mr-2" checked={consult === "SI"} onChange={(e) => e.target.checked ? setConsult("SI") : setConsult("NO")} disabled={Tag === 2}/>
                        <label className="">Remitir a Consultorios</label>   
                      </div>
                      <div className="flex mt-2">
                        <input type="checkbox" className="mr-2" checked={codigoqr === "SI"} onChange={(e) => e.target.checked ? setCodigoQr("SI") : setCodigoQr("NO")} disabled={Tag === 2}/>
                        <label className="">Generar codigo Qr?</label>   
                      </div>
                    </div>  
                    <div className="flex w-full gap-4 mt-6 justify-end">
                       <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                       <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                    </div>
               </form>
            </div>   
      </Modal>
    </>
  );
}

AreaModal.propTypes = {
  show: PropTypes.bool.isRequired,
  AreaI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  fillAreas: PropTypes.func.isRequired,
};

export default AreaModal;
